import getEnv from "env";
import { routes } from "api";
import { services } from "services";
import {
  ACCESS_TOKEN,
  ORIGINAL_URI_TO_RESTORE,
  POST_LOGOUT_REDIRECT_URI,
} from "utils/constants/auth.constants";
import { Path } from "utils/constants/paths.constants";

const getLoginRedirectUrl = () => {
  const lastPath = localStorage.getItem(ORIGINAL_URI_TO_RESTORE);
  let redirectUrl = `${window.location.origin}${lastPath ?? ""}`;
  localStorage.removeItem(ORIGINAL_URI_TO_RESTORE);

  return `${getEnv().apiUrl}${routes.identity.auth.authorize(redirectUrl)}`;
};

export const getLogoutRedirectUrl = (data: { redirectUrl: string }) => {
  return `${data?.redirectUrl}&post_logout_redirect_uri=${POST_LOGOUT_REDIRECT_URI}`;
};

export const setOriginalUriToRestore = () => {
  if (![Path.HomePage, Path.Login].includes(window.location.pathname as Path)) {
    localStorage.setItem(ORIGINAL_URI_TO_RESTORE, window.location.pathname);
  }
};

export const login = () => {
  window.location.href = getLoginRedirectUrl();
};

const setAuthCookie = (value: string) => {
  document.cookie = `${ACCESS_TOKEN}=${value}; path=/;`;
};

export const setAuthCookieForDev = async (value?: string) => {
  if (process.env.NODE_ENV !== "development") {
    return;
  }

  if (typeof value === "string") {
    setAuthCookie(value);
  } else {
    const userSession = await services.auth.getUserSession();

    if (userSession?.data?.accessToken) {
      setAuthCookie(userSession.data.accessToken);
    }
  }
};
